import { gql } from '@apollo/client';

export const UPDATE_ASG = gql`
  mutation createASGPPP($asg: NrAsgpppInput!) {
    updateNrAsgppp(nrAsgppp: $asg) {
      id
    }
  }
`;
